import { Routes } from "src/routes";
import { typeCheckAppModule } from "src/utils";
import { HowToPage } from "./HowToPage";

export const howTo = typeCheckAppModule({
    NAME: "howTo",
    Container: HowToPage,
    route: Routes.howTo,
});
